<template>
    <stick-pop v-bind="$attrs" @click="show">
        <i class="el-icon-download" style="font-weight: 600"></i>
    </stick-pop>
</template>

<script>
    import StickPop from "./StickPop";
    import {getMenuComponent, getMyHeader, isHybridAgent} from "../../../utils";

    export default {
        name: "Deals",
        components: {StickPop},
        methods: {
            show(){
                // if(isHybridAgent()) plus.device.vibrate();
                getMyHeader().$refs.userDealHis.show();
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/Deals.vue